import {constructPartnerAccounts} from "../Factory/factory";
import {findPartnerAccounts} from "../Util/queries";

const PARTNER_ACCOUNTS = "PARTNER_ACCOUNTS";

export const getAccountsDetails = () =>
    async (dispatch) => {
        try {
            let response = await findPartnerAccounts();
            if (response.data) {
                let partnerAccountsObj = constructPartnerAccounts(response.data);
                dispatch({
                    type: PARTNER_ACCOUNTS,
                    payload: partnerAccountsObj
                })
            } else {
                dispatch({
                    type: PARTNER_ACCOUNTS,
                    payload: null
                })
            }
        } catch (e) {
            console.error(e);
            dispatch({
                type: PARTNER_ACCOUNTS,
                payload: null
            })
        }
    }

export {PARTNER_ACCOUNTS}